/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditordishprice3Inputs */

const en_menueditordishprice3 = /** @type {(inputs: Menueditordishprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price`)
};

const de_menueditordishprice3 = /** @type {(inputs: Menueditordishprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis`)
};

/**
* | output |
* | --- |
* | "Price" |
*
* @param {Menueditordishprice3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditordishprice3 = /** @type {((inputs?: Menueditordishprice3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditordishprice3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditordishprice3(inputs)
	return de_menueditordishprice3(inputs)
});
export { menueditordishprice3 as "menuEditorDishPrice" }